<template minapp="mpx" xlang="wxml">
  
  <view class="card-main">
    <image class="auth-icon" src="https://pt-starimg.didistatic.com/static/starimg/img/KhrdC7PyHO1643101554521.png" />
    <view class="title">申请获得以下权限：</view>
    <view class="content">获得您的身份信息(姓名、身份证号)</view>
    <view class ="content">滴滴企业版承诺本次获取权限将完全用于预订火车票,不会进行泄露与其他利用</view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({})
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .card-main
    display flex
    flex-direction column
  .title
    font-size 14px
    color $train-color-333
    font-family PingFangSC
    font-weight bold
    text-align start
  .content
    font-size 12px
    color $train-color-666
    font-family PingFangSC
    text-align start
  .auth-icon
    height 24px
    width 120px
    align-self center
    box-sizing border-box
    margin-bottom 12px
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>